import { FC } from 'react';
import Chip from './';
import { createUseStyles } from 'react-jss';
import { ControlActionValue } from '@/lib/models/policy-model/controls';
import { ChipColor, ChipSize } from './helpers';

export type ControlChipValue = ControlActionValue | 'allow';

interface Props {
  value: ControlChipValue;
  size?: ChipSize;
  circle?: boolean;
}

const ColorMap: Map<ControlChipValue, ChipColor> = new Map();
ColorMap.set('ignore', 'grey');
ColorMap.set('log', 'warning');
ColorMap.set('block', 'error');
ColorMap.set('delete', 'error');
ColorMap.set('allow', 'success');
ColorMap.set('warn', 'warning');
ColorMap.set('tag', 'warning');
ColorMap.set('mask', 'warning');

const LabelMap: Map<ControlChipValue, string> = new Map();
LabelMap.set('ignore', 'Ignore');
LabelMap.set('log', 'Monitor');
LabelMap.set('block', 'Block');
LabelMap.set('delete', 'Delete');
LabelMap.set('allow', 'Allow');
LabelMap.set('warn', 'Warn');
LabelMap.set('tag', 'Tag');
LabelMap.set('mask', 'Mask');

const useStyles = createUseStyles({
  circle: {
    width: 25,
  },
});

const ControlChip: FC<Props> = ({ value, size = 'medium', circle = false }) => {
  const styles = useStyles();
  return (
    <Chip
      label={circle ? '' : LabelMap.get(value) || 'Ignore'}
      color={ColorMap.get(value) || 'primary'}
      size={size}
      className={circle ? styles.circle : ''}
    />
  );
};

export default ControlChip;
